module.exports = __webpack_public_path__ + "img/operationCapacity2.70f54388.png";